import { VendorBuyingAgreementsListVendor } from '../../../components/Vendor';
import { usePageTitle } from '../../../hooks';

export function BuyingAgreements() {
  usePageTitle('vendor:buyingAgreements.title');
  return <VendorBuyingAgreementsListVendor />;
}
